module.exports = __webpack_public_path__ + "static/media/simple-arrow-up.5685203d.svg";